import { useProduct } from 'providers/product.provider';
import { IStepInfo } from 'providers/profile.config';
import {
    AmountRequestedInput, Button,
    ButtonsGroup, Title
} from 'components/commons';
import { Field, Form } from 'components/form-validation';
import { productConfig } from 'constants/constants';
import { LoanApplication } from 'generated/graphql';
import { formatMoneyWithoutDecimals } from 'utils/utils';
import { amountRequestedSchema } from 'validation-schemas/direto';
import React from 'react';


type AmountRequestedLayoutProps = {
    initialValue: LoanApplication;
    stepInfo: IStepInfo;
    loading?: boolean;
    onSubmit(loanApplication: LoanApplication): void;
};

const AmountRequestedLayout: React.FC<AmountRequestedLayoutProps> = ({
    initialValue,
    stepInfo,
    loading = false,
    onSubmit,
}) => {

    const { productBizId } = useProduct();
    const { LOAN_AMOUNT } = productConfig(productBizId);

    const minRequestedValue = formatMoneyWithoutDecimals(LOAN_AMOUNT.MIN());
    const maxRequestedValue = formatMoneyWithoutDecimals(LOAN_AMOUNT.MAX());

    return (
        <div className="screen amount-requested-screen">
            <Form
                schema={amountRequestedSchema(LOAN_AMOUNT.MIN(), LOAN_AMOUNT.MAX())}
                initialValues={initialValue}
                onSubmit={onSubmit}
                render={({ valid }) => (
                    <>
                        <Title>{stepInfo.title}</Title>

                        <div className="requested-value-input">
                            <Field
                                component={AmountRequestedInput}
                                placeholder="R$ 0,00"
                                name="amountRequested"
                                decimalScale={0}
                                prefix="R$ "
                                size="lg"
                                info={`Você pode escolher de R$${minRequestedValue} até R$${maxRequestedValue}`}
                                maxRequestedValue={LOAN_AMOUNT.MAX()}
                            />

                            <div>
                                <span className="info">Sua empresa precisa:<br />
                                    <strong>✔</strong> Faturar mais de R$10mil por mês.<br />
                                    <strong>✔</strong> Ter CNPJ ativo há mais de 1 ano.<br />
                                    <strong>✔</strong> Não ser MEI.</span>
                            </div>

                        </div>

                        <ButtonsGroup>
                            <Button
                                label="continuar"
                                disabled={!valid}
                                loading={loading}
                                type="submit"
                            />
                        </ButtonsGroup>
                    </>
                )}
            />
        </div>
    )
};

export default AmountRequestedLayout;
